<template>
  <div class="welcome-package">
    <h1 class="visually-hidden">
      {{ getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'welcome.label') }}
    </h1>
    <welcome-package-intro
      :title="getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'title')"
      :description="getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'description')"
      :how-get-label="getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'howGet.label')"
      :how-get-steps="
        getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'howGet.steps', [])
      "
    />

    <welcome-package-card
      v-if="getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'welcome.items')?.length"
      :title="getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'welcome.label')"
      :cardItems="getContent(welcomeContent?.currentLocaleData, welcomeContent?.defaultLocaleData, 'welcome.items')"
    />
  </div>
</template>

<script setup lang="ts">
  import type { IWelcomeBonusesPage } from '~/types';

  const { getContent } = useProjectMethods();

  const { getContentData } = useContentLogic<IWelcomeBonusesPage>({
    contentKey: 'welcomePageContent',
    contentRoute: ['pages', 'welcome-bonuses'],
    isPage: true,
  });

  const { data: welcomeContent } = await useLazyAsyncData(getContentData);

  const loadingStore = useLoadingStore();

  watchEffect(() => {
    loadingStore.setLoadingState(!welcomeContent.value);
  });
</script>

<style src="~/assets/styles/pages/welcome-package.scss" lang="scss" />
